module.exports = __webpack_public_path__ + "img/nav-logo.e2b2e44b.png";